<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="7"
    viewBox="0 0 13 7"
    class="carat"
    v-on:click="svgClick"
  >
    <path
      fill="none"
      fill-rule="evenodd"
      stroke="#54392D"
      stroke-linecap="round"
      stroke-width="1.5"
      d="M.82 1.1l5.366 4.887 5.335-4.92"
    />
  </svg>
</template>
<script>
export default {
  methods: {
    svgClick(e) {
      this.$emit('caratsvg-click', e)
    },
  },
}
</script>
